type Order = {
  confirmedAt: Date | null;
  dispatchedAt: Date | null;
  deliveredAt: Date | null;
  Supplier: {
    invoiceCreationStage: "confirmed" | "dispatched" | "delivered";
  };
};
export const canEditInvoice = (order: Order) => {
  const invoiceCreationStage = order.Supplier.invoiceCreationStage;
  if (order.confirmedAt && invoiceCreationStage === "confirmed") {
    return false;
  }

  if (order.dispatchedAt && invoiceCreationStage === "dispatched") {
    return false;
  }

  if (order.deliveredAt && invoiceCreationStage === "delivered") {
    return false;
  }

  return true;
};
